import { render } from "./PuzzleDetailsView.vue?vue&type=template&id=47d3cccb&scoped=true"
import script from "./PuzzleDetailsView.vue?vue&type=script&lang=js"
export * from "./PuzzleDetailsView.vue?vue&type=script&lang=js"

import "./PuzzleDetailsView.vue?vue&type=style&index=0&id=47d3cccb&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d3cccb"]])

export default __exports__